/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetContentAreaSkillProficienciesR200ResponseInnerAnyOfProficiencyFromJSON, GetContentAreaSkillProficienciesR200ResponseInnerAnyOfProficiencyToJSON, } from './GetContentAreaSkillProficienciesR200ResponseInnerAnyOfProficiency';
/**
 * Check if a given object implements the GetContentAreaSkillProficienciesR200ResponseInner interface.
 */
export function instanceOfGetContentAreaSkillProficienciesR200ResponseInner(value) {
    if (!('grade' in value) || value['grade'] === undefined)
        return false;
    if (!('isFocus' in value) || value['isFocus'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('numCorrectAnswers' in value) || value['numCorrectAnswers'] === undefined)
        return false;
    if (!('numQuestionsAnswered' in value) || value['numQuestionsAnswered'] === undefined)
        return false;
    if (!('proficiency' in value) || value['proficiency'] === undefined)
        return false;
    if (!('progressionOrder' in value) || value['progressionOrder'] === undefined)
        return false;
    if (!('removed' in value) || value['removed'] === undefined)
        return false;
    if (!('shortName' in value) || value['shortName'] === undefined)
        return false;
    if (!('standardId' in value) || value['standardId'] === undefined)
        return false;
    if (!('standardSetId' in value) || value['standardSetId'] === undefined)
        return false;
    if (!('studentId' in value) || value['studentId'] === undefined)
        return false;
    if (!('uspId' in value) || value['uspId'] === undefined)
        return false;
    return true;
}
export function GetContentAreaSkillProficienciesR200ResponseInnerFromJSON(json) {
    return GetContentAreaSkillProficienciesR200ResponseInnerFromJSONTyped(json, false);
}
export function GetContentAreaSkillProficienciesR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return Object.assign(Object.assign({}, json), { 'grade': json['grade'], 'isFocus': json['isFocus'], 'name': json['name'], 'numCorrectAnswers': json['numCorrectAnswers'], 'numCorrectOfLast5Answers': json['numCorrectOfLast5Answers'] == null ? undefined : json['numCorrectOfLast5Answers'], 'numQuestionsAnswered': json['numQuestionsAnswered'], 'proficiency': GetContentAreaSkillProficienciesR200ResponseInnerAnyOfProficiencyFromJSON(json['proficiency']), 'progressionOrder': json['progressionOrder'], 'removed': json['removed'], 'shortName': json['shortName'], 'skillSetProgressionOrder': json['skillSetProgressionOrder'] == null ? undefined : json['skillSetProgressionOrder'], 'standardId': json['standardId'], 'standardSetId': json['standardSetId'], 'starProgressionOrder': json['starProgressionOrder'] == null ? undefined : json['starProgressionOrder'], 'starProgressionScore': json['starProgressionScore'] == null ? undefined : json['starProgressionScore'], 'studentId': json['studentId'], 'uspId': json['uspId'] });
}
export function GetContentAreaSkillProficienciesR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return Object.assign(Object.assign({}, value), { 'grade': value['grade'], 'isFocus': value['isFocus'], 'name': value['name'], 'numCorrectAnswers': value['numCorrectAnswers'], 'numCorrectOfLast5Answers': value['numCorrectOfLast5Answers'], 'numQuestionsAnswered': value['numQuestionsAnswered'], 'proficiency': GetContentAreaSkillProficienciesR200ResponseInnerAnyOfProficiencyToJSON(value['proficiency']), 'progressionOrder': value['progressionOrder'], 'removed': value['removed'], 'shortName': value['shortName'], 'skillSetProgressionOrder': value['skillSetProgressionOrder'], 'standardId': value['standardId'], 'standardSetId': value['standardSetId'], 'starProgressionOrder': value['starProgressionOrder'], 'starProgressionScore': value['starProgressionScore'], 'studentId': value['studentId'], 'uspId': value['uspId'] });
}
